/**
 * VSB Verkoop — Vue IIFE voor productpagina (mount op #vsb-vue-product).
 */
import { createApp } from 'vue';
import ProductPageApp from '../features/product/ProductPageApp.vue';

const mountSelector = '#vsb-vue-product';

function bootProductPageWidget() {
  const el = document.querySelector(mountSelector);
  if (!el || el.dataset.vsbVueAutostart === '0') {
    return;
  }
  createApp(ProductPageApp).mount(el);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootProductPageWidget);
} else {
  bootProductPageWidget();
}
